import api from '../api';
import * as types from './mutations-types';

const fetchEstudantes = ({
  commit,
  dispatch,
  getters
}) => {
  commit(types.SET_ESTUDANTES, []);
  api.fetchEstudantes({
      unidade: getters.formBusca.unidade ? getters.formBusca.unidade.nome : "",
      modalidade: getters.formBusca.modalidade ? getters.formBusca.modalidade.nome : "",
      curso: getters.formBusca.curso ? getters.formBusca.curso.nome : "",
      versao: getters.formBusca.versao ? getters.formBusca.versao.nome : "",
      turma: getters.formBusca.turma ? getters.formBusca.turma.nome : "",
      nome: getters.formBusca.nome,
      pagina: getters.formBusca.pagina,
      campo_ordem: getters.ordenacaoBusca.campo,
      ordem: getters.ordenacaoBusca.ordem,
      min_evasao: getters.formBusca.faixa_evasao[0],
      max_evasao: getters.formBusca.faixa_evasao[1]
    })
    .then((response) => {
      commit(types.SET_ESTUDANTES, response.estudantes);
      commit(types.SET_PAGINACAO, response.paginacao);
      if (!response.estudantes.length) {
        dispatch('showMessage', {
          type: "danger",
          content: "Não foi encontrado nenhum estudante"
        }, {
          root: true
        });
      }
    })
    .catch((error) => {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi possível buscar os estudantes"
      }, {
        root: true
      });
    });
};

const fetchEstudante = ({
  commit,
  dispatch
}, id_matricula) => {
  commit(types.SET_ESTUDANTE, null);
  api.fetchEstudante(id_matricula)
    .then((response) => {
      commit(types.SET_ESTUDANTE, response.estudante);
      if (!response.estudante) {
        dispatch('showMessage', {
          type: "danger",
          content: "Estudante não existente"
        }, {
          root: true
        });
      }
    })
    .catch((error) => {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi possível localizar o estudante"
      }, {
        root: true
      });
    });
};


const fetchUnidades = ({
  commit,
  dispatch
}) => {
  commit(types.SET_UNIDADES, []);
  api.fetchUnidades()
    .then((response) => {
      commit(types.SET_UNIDADES, response.unidades);
      if (!response.unidades.length) {
        dispatch('showMessage', {
          type: "danger",
          content: "Não foi encontrado nenhuma unidade com alunos regulares"
        }, {
          root: true
        });
      }
    })
    .catch((error) => {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi possível buscar as unidades"
      }, {
        root: true
      });
    });
};

const fetchModalidades = ({
  commit,
  dispatch
}, params) => {
  commit(types.SET_MODALIDADES, []);
  api.fetchModalidades(params)
    .then((response) => {
      commit(types.SET_MODALIDADES, response.modalidades);
      if (!response.modalidades.length) {
        dispatch('showMessage', {
          type: "danger",
          content: "Não foi encontrado nenhuma modalidade com alunos regulares"
        }, {
          root: true
        });
      }
    })
    .catch((error) => {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi possível realizar a busca de modalidades"
      }, {
        root: true
      });
    });
};

const fetchCursos = ({
  commit,
  dispatch
}, params) => {
  commit(types.SET_CURSOS, []);
  api.fetchCursos(params)
    .then((response) => {
      commit(types.SET_CURSOS, response.cursos);
      if (!response.cursos.length) {
        dispatch('showMessage', {
          type: "danger",
          content: "Não foi encontrado nenhum curso com alunos regulares"
        }, {
          root: true
        });
      }
    })
    .catch((error) => {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi possível realizar a busca de cursos"
      }, {
        root: true
      });
    });
};


const fetchTurmas = ({
  commit,
  dispatch
}, params) => {
  commit(types.SET_TURMAS, []);
  api.fetchTurmas(params)
    .then((response) => {
      commit(types.SET_TURMAS, response.turmas);
      if (!response.turmas.length) {
        dispatch('showMessage', {
          type: "danger",
          content: "Não foi encontrado nenhuma turma"
        }, {
          root: true
        });
      }
    })
    .catch((error) => {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi possível realizar a busca de turmas"
      }, {
        root: true
      });
    });
};

const fetchVersoes = ({
  commit,
  getters,
  dispatch
}, params) => {
  let versoes = []
  commit(types.SET_VERSOES, versoes);
  let cursoSelecionado = getters.formBusca.cursos.find(curso => {
    return curso.nome == params.curso;
  });

  if (cursoSelecionado) {
    cursoSelecionado.versoes.forEach(versao => {
      versoes.push({
        'nome': String(versao)
      });
    });
    commit(types.SET_VERSOES, versoes);
  }
};

const fetchVariaveisSimulacao = ({
  commit,
  dispatch,
  getters
}) => {
  commit(types.SET_VARIAVEIS_SIMULACAO, []);
  commit(types.SET_FORM_SIMULACAO, {});
  api.fetchVariaveisSimulacao()
    .then((response) => {

      let variaveis = response.variaveis;
      commit(types.SET_VARIAVEIS_SIMULACAO, variaveis);

      let formSimulacao = {}
      variaveis.forEach(variavel => {
        formSimulacao[variavel.nome] = getters.estudante[variavel.nome];
      });
      commit(types.SET_FORM_SIMULACAO, formSimulacao);

      if (!response.variaveis.length) {
        dispatch('showMessage', {
          type: "danger",
          content: "Não foi encontrado nenhuma variável para simulação"
        }, {
          root: true
        });
      }
    })
    .catch((error) => {
      dispatch('showMessage', {
        type: "danger",
        content: "Ocorreu um erro ao carregar as variáveis para simulação"
      }, {
        root: true
      });
    });
};

const fetchSimulacao = ({
  commit,
  dispatch,
  getters
}, params) => {
  let id_matricula = getters.estudante.id_matricula;
  commit(types.SET_ESTUDANTE_SIMULACAO, null);
  api.fetchSimulacao(id_matricula, params)
    .then((response) => {
      commit(types.SET_ESTUDANTE_SIMULACAO, response.estudante);
      if (!response.estudante) {
        dispatch('showMessage', {
          type: "danger",
          content: "Não foi encontrado os dados do estudante para simulação"
        }, {
          root: true
        });
      }
    })
    .catch((error) => {
      dispatch('showMessage', {
        type: "danger",
        content: "Ocorreu um erro ao gerar a simulação"
      }, {
        root: true
      });
    });
};

const fetchVariaveisImportancia = ({
  commit,
  dispatch,
  getters
}) => {
  let id_matricula = getters.estudante.id_matricula;
  commit(types.SET_VARIAVEIS_IMPORTANCIA, []);
  api.fetchVariaveisImportancia(id_matricula)
    .then((response) => {
      commit(types.SET_VARIAVEIS_IMPORTANCIA, response.variaveis);
    })
    .catch((error) => {
      dispatch('showMessage', {
        type: "danger",
        content: "Ocorreu um erro ao carregar a importância das variáveis do estudante"
      }, {
        root: true
      });
    });
};

const fetchVariaveisAbaInformacoes = ({
  commit,
  dispatch,
  getters
}) => {
  let id_matricula = getters.estudante.id_matricula;
  commit(types.SET_VARIAVEIS_INFORMACOES, []);
  api.fetchVariaveisAbaInformacoes(id_matricula)
    .then((response) => {
      commit(types.SET_VARIAVEIS_INFORMACOES, response.variaveis);
      if (!response.variaveis.length) {
        dispatch('showMessage', {
          type: "danger",
          content: "Não foi encontrado as variáveis com as informações do estudante"
        }, {
          root: true
        });
      }
    })
    .catch((error) => {
      dispatch('showMessage', {
        type: "danger",
        content: "Ocorreu um erro ao carregar as variáveis com as informações do estudante"
      }, {
        root: true
      });
    });
};



export default {
  fetchEstudantes,
  fetchEstudante,
  fetchUnidades,
  fetchModalidades,
  fetchCursos,
  fetchTurmas,
  fetchVersoes,
  fetchVariaveisSimulacao,
  fetchSimulacao,
  fetchVariaveisImportancia,
  fetchVariaveisAbaInformacoes
};



// WEBPACK FOOTER //
// ./src/pages/estudantes/store/actions.js